module.exports = __webpack_public_path__ + "assets/cheerup1.65903b8d.svg";